import { useGetEmployeeByReport } from '../services/api';
import { EmployeesTableSimple } from './EmployeesTableSimple';

export const ReportsEmployeeTable: React.FC<{ reportId: string }> = ({ reportId }) => {
  const { data, error, isLoading } = useGetEmployeeByReport({ reportId });
  return <EmployeesTableSimple data={data} isLoading={isLoading} error={error} />;
};
